export default __webpack_public_path__ + "static/media/Coulomb_AI.184f035a.svg";